module.exports = __webpack_public_path__ + "img/paid-coupon-active.c0fadffb.svg";